import { render, staticRenderFns } from "./ReturnSvg.vue?vue&type=template&id=180238c2"
import script from "./ReturnSvg.vue?vue&type=script&lang=js"
export * from "./ReturnSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports